/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Parent_SelfInputs */

const en_sch_err_parent_self = /** @type {(inputs: Sch_Err_Parent_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A type cannot be its own parent.`)
};

const de_sch_err_parent_self = /** @type {(inputs: Sch_Err_Parent_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Typ kann nicht sein eigener übergeordneter Typ sein.`)
};

/**
* | output |
* | --- |
* | "A type cannot be its own parent." |
*
* @param {Sch_Err_Parent_SelfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_parent_self = /** @type {((inputs?: Sch_Err_Parent_SelfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Parent_SelfInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_parent_self(inputs)
	return en_sch_err_parent_self(inputs)
});